export default __webpack_public_path__ + "static/media/nitroMenu.e21573ec.webp";